@if (esActivo === true) {
<a href="javascript:void(0);" (click)="activarInactivarRegistro('N')" title="Inactivar"
  class="btn btn-outline-danger btn-icon waves-effect waves-light btn-sm action-btn">
  <i class="ri-lock-2-line fs-5"></i>
</a>
}@else {
<a href="javascript:void(0);" (click)="activarInactivarRegistro('S')" title="Activar"
  class="btn btn-outline-success btn-icon waves-effect waves-light btn-sm action-btn">
  <i class="ri-lock-unlock-line fs-5"></i>
</a>
}